module.exports = __webpack_public_path__ + "img/1970East-041_WEB-min.f90a9f4d.jpg";